import * as React from "react";
import Image from "next/image";

const LogoWithImage = ({
  src,
  alt = "CDP Logo",
  width = 73.344,
  height = 25.728,
  ...props
}) => {
  // Calculate center position for the image area
  const centerX = 18.309 + 73.344 / 2; // 54.981
  const centerY = 42.131 + 25.728 / 2; // 54.995

  // Calculate foreignObject position to center the image
  const foreignObjectX = centerX - width / 2;
  const foreignObjectY = centerY - height / 2;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={108}
      height={109}
      fill="none"
      {...props}
    >
      <rect width={100} height={100} x={4} y={4.918} fill="#fff" rx={50} />
      <rect
        width={100}
        height={100}
        x={4}
        y={4.918}
        stroke="#FDECEB"
        strokeWidth={8}
        rx={50}
      />
      <foreignObject
        x={foreignObjectX}
        y={foreignObjectY}
        width={width}
        height={height}
      >
        <Image
          src={src}
          alt={alt}
          width={width}
          height={height}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </foreignObject>
    </svg>
  );
};

export default LogoWithImage;
